export default __webpack_public_path__ + "static/media/love.c658ea33.png";